import { connect } from 'react-redux'
import SchoolTeachersFilter from './teachers-filter'
import { getFilterSearch } from '../../../../stores/school-teachers-filter/school-teachers-filter.selectors'
import { setSearchValue } from '../../../../stores/school-teachers-filter/school-teachers-filter.actions.js'

const mapStateToProps = state => ({
  searchValue: getFilterSearch(state)
})

const mapDispatchToProps = dispatch => ({
  onSearchChange: e => dispatch(setSearchValue(e.target.value))
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SchoolTeachersFilter)
